import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { DownloadPage } from './DownloadPage'
import { useDownload } from './useDownload'

const COUNTDOWN_SECONDS = 5

export default function DownloadRoute() {
    const { type, id } = useParams<{ type: string; id: string }>()
    const { link, filename, error } = useDownload(type, id)
    const [countdown, setCountdown] = useState<number | null>(null)
    const intervalRef = useRef<NodeJS.Timeout>()

    useEffect(() => {
        if (link && countdown === null) {
            setCountdown(COUNTDOWN_SECONDS)
        }
    }, [link, countdown])

    useEffect(() => {
        if (countdown === null) return

        if (countdown === 0) {
            if (link) window.location.href = link
            return
        }

        intervalRef.current = setTimeout(() => {
            setCountdown((c) => (c !== null ? c - 1 : null))
        }, 1000)

        return () => {
            if (intervalRef.current) {
                clearTimeout(intervalRef.current)
            }
        }
    }, [countdown, link])

    const handleDownload = () => {
        if (link) {
            window.location.href = link
        }
    }

    return (
        <DownloadPage
            link={link}
            filename={filename}
            error={error}
            countdown={countdown}
            onDownload={handleDownload}
        />
    )
}
